// Mock data for OpaLink Telecom

export const heroSlides = [
  {
    id: 1,
    title: "JOGUE ONLINE\nSEM LAG",
    image: "https://customer-assets.emergentagent.com/job_web-clone-project-10/artifacts/xwjiiptn_image.png",
    buttonText: "Contrate já",
    buttonLink: "https://api.whatsapp.com/send?phone=5588996105011&text=Olá%20gostaria%20de%20contratar%20o%20plano%20de%20internet"
  },
  {
    id: 2,
    title: "OUÇA SUAS\nMÚSICAS\nSEM PARAR",
    image: "https://customer-assets.emergentagent.com/job_web-clone-project-10/artifacts/sjay3b96_image.png",
    buttonText: "Contrate já",
    buttonLink: "https://api.whatsapp.com/send?phone=5588996105011&text=Olá%20gostaria%20de%20contratar%20o%20plano%20de%20internet"
  },
  {
    id: 3,
    title: "SEMPRE\nCONECTADO\nCOM SUA FAMÍLIA",
    image: "https://customer-assets.emergentagent.com/job_web-clone-project-10/artifacts/nw8of8nm_image.png",
    buttonText: "Contrate já",
    buttonLink: "https://api.whatsapp.com/send?phone=5588996105011&text=Olá%20gostaria%20de%20contratar%20o%20plano%20de%20internet"
  },
  {
    id: 4,
    title: "NÃO PERCA\nNENHUM LANCE\nDO SEU TIME",
    image: "https://customer-assets.emergentagent.com/job_web-clone-project-10/artifacts/my099aly_image.png",
    buttonText: "Contrate já",
    buttonLink: "https://api.whatsapp.com/send?phone=5588996105011&text=Olá%20gostaria%20de%20contratar%20o%20plano%20de%20internet"
  }
];

export const advantages = [
  {
    id: 1,
    icon: "Zap",
    title: "Instalação imediata",
    description: "Suporte técnico especializado."
  },
  {
    id: 2,
    icon: "DollarSign",
    title: "Custo benefício",
    description: "Planos e preços que cabe no seu bolso"
  },
  {
    id: 3,
    icon: "Cable",
    title: "Internet Fibra Óptica",
    description: "Ultra velocidade para você curtir o melhor."
  },
  {
    id: 4,
    icon: "Wifi",
    title: "Wi-Fi turbo grátis",
    description: "Velocidade máxima para sua conexão"
  },
  {
    id: 5,
    icon: "Headphones",
    title: "Atendimento especializado",
    description: "Suporte técnico quando você precisar"
  },
  {
    id: 6,
    icon: "Gamepad2",
    title: "Internet para games",
    description: "Baixa latência para jogos online"
  }
];

export const plans = [
  {
    id: 1,
    speed: "200",
    price: "69,99",
    featured: false,
    features: [
      "Wi-fi 5G incluso",
      "Suporte Premium",
      "200 mega de Download",
      "100 mega de Upload"
    ],
    services: []
  },
  {
    id: 2,
    speed: "300",
    price: "79,99",
    featured: true,
    features: [
      "Wi-fi 5G incluso",
      "Suporte Premium",
      "300 mega de Download",
      "150 mega de Upload"
    ],
    services: ["watch"]
  },
  {
    id: 3,
    speed: "500",
    price: "89,99",
    featured: false,
    features: [
      "Wi-fi 6G incluso",
      "Suporte Premium",
      "500 mega de Download",
      "250 mega de Upload"
    ],
    services: ["watch", "gaming"]
  },
  {
    id: 4,
    speed: "600",
    price: "99,99",
    featured: false,
    features: [
      "Wi-fi 6G incluso",
      "Suporte Premium",
      "600 mega de Download",
      "300 mega de Upload"
    ],
    services: ["watch", "gaming"]
  }
];

export const contactInfo = {
  phone: "5588996105011",
  whatsappLink: "https://api.whatsapp.com/send?phone=5588996105011&text=Olá%20gostaria%20de%20contratar%20o%20plano%20de%20internet",
  clientAreaLink: "https://sistema.opalink.com.br/central_assinante_web/login",
  hours: {
    weekdays: "Segunda à Sexta\n07:00 – 17:30",
    saturday: "Sábado\n07:30 – 12:00"
  },
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100081954828933",
    instagram: "https://www.instagram.com/opalink_telecom/",
    whatsapp: "https://api.whatsapp.com/send?phone=5588996105011&text=Olá%20gostaria%20de%20contratar%20o%20plano%20de%20internet"
  }
};

export const aboutContent = {
  title: "Sobre a OpaLink Telecom",
  description: "Somos uma empresa especializada em provedores de internet via fibra óptica, oferecendo conexões de alta velocidade e qualidade para residências e empresas.",
  mission: "Nossa missão é conectar pessoas e empresas com internet de qualidade, velocidade e suporte técnico especializado.",
  values: [
    "Qualidade no atendimento",
    "Tecnologia de ponta",
    "Compromisso com o cliente",
    "Transparência",
    "Inovação constante"
  ]
};

export const businessPlans = [
  {
    id: 1,
    speed: "500",
    price: "149,99",
    features: [
      "IP Fixo",
      "Suporte 24/7",
      "SLA garantido",
      "500 mega de Download",
      "500 mega de Upload"
    ]
  },
  {
    id: 2,
    speed: "1 GIGA",
    price: "249,99",
    features: [
      "IP Fixo",
      "Suporte 24/7",
      "SLA garantido",
      "1 Giga de Download",
      "1 Giga de Upload"
    ]
  }
];
